import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';

export type Tabs = 'monitored' | 'recent';
type ContextValue =
    | {
          tab: Tabs;
          setTab: Dispatch<SetStateAction<Tabs>>;
      }
    | undefined;

const MonitoredEventsDrawerTabContext = createContext<ContextValue>(undefined);

export function MonitoredEventsDrawerTabProvider(props: { children: React.ReactNode }) {
    const [tab, setTab] = useState<Tabs>('monitored');

    const contextVal = useMemo(
        () => ({
            tab,
            setTab,
        }),
        [tab]
    );
    return (
        <MonitoredEventsDrawerTabContext.Provider value={contextVal}>
            {props.children}
        </MonitoredEventsDrawerTabContext.Provider>
    );
}

export function useMonitoredEventsDrawerTab(): ContextValue {
    return useContext(MonitoredEventsDrawerTabContext);
}
